import {Component, OnInit, OnDestroy, AfterViewInit} from '@angular/core';
import * as $ from 'jquery';
import {PromocionesListComponent} from './promociones-list.component';
import {PromocionesService} from './promociones.service';
import {IPromocion} from './promocion';
import * as myGlobals from './../global';
import {IIssuer} from '../ruteo/issuer';
import {Observable} from 'rxjs';
import {RuteosService} from '../ruteo/ruteos.service';
import { errorMessageFromAjax } from '../services/ajax-error';

@Component({
  selector: 'pm-edit-promocion',
  templateUrl: './edit-promocion.component.html',
  styleUrls: ['./edit-promocion.component.sass'],
  providers: [PromocionesService]
})
export class EditPromocionComponent implements OnInit, OnDestroy, AfterViewInit {
  promociones: IPromocion[] = [];
  errorMessage = '';
  promocion: IPromocion;


  issuerSelected: any;
  issuerList: Observable<IIssuer[]> = this.routingService.getIssuers();

  constructor(public service: PromocionesService,
              private parent: PromocionesListComponent,
              private routingService: RuteosService) {
  }

  ngOnInit() {
    console.log('EditPromocionComponent: OnInit: id: ', this.parent.editnumber);
    this.getPromocion(this.parent.editnumber);
  }

  ngAfterViewInit() {
    $('a[rel=promociones]').addClass('selected');
  }

  edit(elemento): boolean {
    console.log('edit:' + elemento.parent.editnumber);
    const formData = {
      interestFreeMonths: $('input[name=interestFreeMonths]').val(),
      minimumAmount: $('input[name=minimumAmount]').val(),
      status: $('#status option:selected').val(),
      cardIssuerId: $('#cardIssuerId option:selected').val()
    };
    console.log('EditPromocionComponent: edit: formData: ', formData);

    const parentRef = this.parent;

    $.ajax({
      url: myGlobals.baseApi + '/webadmin/v1/promotion/' + elemento.parent.editnumber,
      dataType: 'json',
      headers: {
        sessionToken: localStorage.getItem('sessionToken')
      },
      contentType: 'application/json; charset=utf-8',
      type: 'PUT',
      data: JSON.stringify(formData)
    }).done(function (response) {
      console.log('delete sucess!!');
      parentRef.showPromociones = true;
      parentRef.showAddPromocion = false;
      parentRef.showEditPromocion = false;
    }).fail(function(jqXHR) {
      alert('No se pudo actualizar la promocion: ' + errorMessageFromAjax(jqXHR));
    });
    return false;
  }

  getPromocion(id: number): any {
    this.service
      .getPromocion(id)
      .subscribe(promocion => {
          this.promocion = promocion;
          this.issuerSelected = promocion.cardIssuerId;
        },
        error => (this.errorMessage = error as any)
      )
    ;
  }

  cancelPromocion(): void {
    this.parent.showPromociones = true;
    this.parent.showAddPromocion = false;
    this.parent.showEditPromocion = false;
  }

  ngOnDestroy() {
    $('a[rel=promociones]').removeClass('selected');
  }
}
